@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.base-content-container {
  background-color: @orders-drawer--single-csw--background-color;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
}

.header {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
}
